module.exports = __webpack_public_path__ + "static/img/KeepNeye.5ced729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/KeepNeye.png
// module id = 260
// module chunks = 1